var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUpTriangle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 7,
  height: 7,
  viewBox: "0 0 7 7"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
  id: "uptriangle-a",
  points: "0 0 6 0 6 4 0 4"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(1 2)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "uptriangle-b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#uptriangle-a"
})), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M4.9961,4 L1.0051,4 C0.1661,4 -0.3029,3.031 0.2191,2.374 L2.3491,0.24 C2.7241,-0.08 3.2761,-0.08 3.6511,0.24 L5.7811,2.376 C6.3021,3.032 5.8341,4 4.9961,4",
  mask: "url(#uptriangle-b)"
}))));
export default SvgUpTriangle;